<template>
	<div class="white pos-rel rounded-lg min-h-screen">
		<div class="header">
			<v-btn fab flat @click="closeModal">
				<v-icon>close</v-icon>
			</v-btn>

			<div>Host Performance</div>
			<v-btn fab flat icon @click="downLoadHostPerformance">
				<v-icon>download</v-icon>
			</v-btn>
		</div>

		<v-card class="pa-2 ma-2" :class="{ 'pa-5': !isSmallScreen }">
			<v-layout
				class="d-flex flex-row"
				:class="{
					'flex-column': isSmallScreen,
					'align-center': !isSmallScreen
				}"
			>
				<v-autocomplete
					v-model="selectedYear"
					label="Select Year"
					:items="filterYears"
					:autcomplete="false"
					placeholder="Year"
					class="ml-2 mr-2"
				/>
				<v-autocomplete
					v-model="selectedMonth"
					label="Select Month"
					:items="filterMonths"
					:autcomplete="false"
					placeholder="Month"
					class="ml-2 mr-2"
				/>

				<v-text-field
					v-model="searchForHandle"
					:label="`Search By Handle `"
					:color="themeColor"
					class="ml-2 mr-2"
				/>

				<v-btn
					:disabled="!selectedMonth || !selectedYear"
					class="white--text rounded-pill"
					color="primary"
					@click="handleSearch"
				>
					Search
				</v-btn>
			</v-layout>
			<v-layout>
				<v-flex>
					<p class="refreshText">Data refreshes at 4AM daily</p>
				</v-flex>
			</v-layout>
			<v-layout>
				<v-flex class="mt-3">
					<div @click="handleRowClick">
						<v-data-table
							:headers="tableHeaders"
							:items="allInvites"
							:loading="isGetInviteLoading"
							hide-actions
							disable-initial-sort
							sort-icon=""
						>
							<template v-slot:headers="props">
								<tr>
									<th
										v-for="header in props.headers"
										:key="header.text"
										class="text-left headerText"
									>
										{{ header.text }}
										<v-tooltip
											v-if="header.value === 'liveDays'"
											bottom
										>
											<template v-slot:activator="{ on }">
												<v-icon
													size="18"
													color="black"
													dark
													v-on="on"
													>info_outline</v-icon
												>
											</template>
											<span
												>Live Day is counted only if the
												host went live for at least 15
												mins that day</span
											>
										</v-tooltip>
									</th>
								</tr>
							</template>
							<template v-slot:items="props">
								<tr
									style="cursor: pointer;"
									:data-creatorId="props.item.creatorId"
								>
									<td>
										<div class="name-col">
											<v-avatar
												color="#A3AED0"
												size="45px"
											>
												<img
													:src="props.item.pic"
													alt="profilepic"
												/>
											</v-avatar>
											<span class="creator-name">
												{{ props.item.name || "NA" }}
											</span>
										</div>
									</td>

									<td>{{ props.item.agencyRank || "NA" }}</td>

									<td>
										{{
											Math.round(props.item.mintsYday) ||
												"NA"
										}}
									</td>
									<td>
										{{
											Math.round(
												props.item.mintsLastWeek
											) || "NA"
										}}
									</td>

									<td>
										{{
											Math.round(props.item.mintsMtd) ||
												"NA"
										}}
									</td>
									<td>
										{{ props.item.liveDays || "NA" }}
									</td>
									<td>
										{{ props.item.liveHours || "NA" }}
									</td>
								</tr>
							</template>
						</v-data-table>
					</div>
				</v-flex>
			</v-layout>
			<div v-if="!isGetInviteLoading && allInvites.length > 0">
				<custom-table-footer
					:goBackward="goBackward"
					:goForward="goForward"
					:onRowNumberChange="onRowNumberChange"
					:offset="offset"
					:nextOffset="nextOffset"
					:totalFetchedRows="allInvites.length"
					:totalEntries="totalEntries"
					:selectedRows="rowNumbers"
				/>
			</div>
		</v-card>
		<v-dialog width="600px" fullscreen v-model="creatorDialog">
			<template v-if="creatorDialog">
				<creator-info
					@CLOSE_CREATOR_MODAL="closeCreatorModal"
					model="creatorDialog"
					:agencyId="this.agencyId"
					:creatorId="this.creatorId"
				/>
			</template>
		</v-dialog>
	</div>
</template>

<script>
import { SHOW_ALERT } from "@/store/action-types";
import ApiService from "@/store/api-service";
import CreatorInfo from "./creator-info.vue";
import { MOJ_TOOLS_BASE_URL, MOJ_TOOLS_ACCESS_TOKEN } from "../../../config";
import { MONTHS } from "../constants";
import CustomTableFooter from "./custom-table-footer.vue";
import { downloadArrayAsCsv, getCsvRows } from "../../utils";
export default {
	name: "InvitationTable",
	props: ["model", "themeColor", "agencyId"],
	data() {
		return {
			isProcessInviteLoading: false,

			searchForHandle: null,
			creatorId: null,
			selectedMonth: MONTHS[new Date().getMonth()],
			allInvites: [],
			headers: [
				{
					text: "Host",
					value: "host",
					align: "left"
				},
				{
					text: "Rank",
					value: "rank",
					align: "left"
				},
				{
					text: "Mints Yday",
					value: "mintsYday",
					align: "left"
				},
				{
					text: "Mints Last Week",
					value: "mintsLastWeek",
					align: "left"
				},
				{
					text: "Mints MTD",
					align: "left",
					value: "mintsMtd"
				},
				{
					text: "Live Days",
					align: "left",
					value: "liveDays"
				},
				{
					text: "Live Hours",
					align: "left",
					value: "liveHours"
				}
			],
			isGetInviteLoading: true,
			inviteCreatorDialog: false,
			inviteCreatorLoading: false,
			triggerDataReset: false,
			creatorDialog: false,
			bulkDownload: false,
			selectedYear: new Date().getFullYear(),
			offset: 0,
			nextOffset: 0,
			totalEntries: 0,
			rowNumbers: 10,
			overallCsvHeaders: {
				HostId: "creatorId",
				HostHandle: "handle",
				HostName: "name",
				RankInAgency: "agencyRank",
				MintsYesterday: "mintsYday",
				MintsLastWeek: "mintsLastWeek",
				MintsEarned: "mintsMtd",
				LiveDays: "liveDays",
				LiveHours: "liveHours"
			},
			keysToRound: ["mintsYday", "mintsLastWeek", "mintsMtd"]
		};
	},
	components: {
		"creator-info": CreatorInfo,
		"custom-table-footer": CustomTableFooter
	},

	mounted() {
		this.fetchTableData();
	},
	computed: {
		filterYears() {
			return [2024, 2025];
		},
		filterMonths() {
			const currentDate = new Date();
			const currentYear = currentDate.getFullYear();
			const currentMonth = currentDate.getMonth() + 1;
			return currentYear === this.selectedYear
				? MONTHS.slice(0, currentMonth)
				: MONTHS;
		},
		isSmallScreen() {
			let screen_size = this.$vuetify.breakpoint.name;
			return screen_size === "xs" || screen_size === "sm";
		},
		tableHeaders() {
			let headers = this.headers;
			return headers;
		}
	},
	methods: {
		handleSearch() {
			if (
				this.selectedMonth ||
				this.selectedYear ||
				this.searchForHandle
			) {
				this.fetchTableData();
				// this.resetFilters();
			}
		},
		resetFilters() {
			this.searchForHandle = null;
			this.selectedMonth = "";
			this.selectedYear = "";
		},
		handleRowClick(event) {
			const row = event.target.closest("tr");
			if (row && row.hasAttribute("data-creatorId")) {
				const id = JSON.parse(row.getAttribute("data-creatorId"));
				this.creatorDialog = true;
				this.creatorId = id;
			}
		},

		closeModal() {
			this.$emit("CLOSE_MODAL", this.model);
		},
		closeCreatorModal() {
			this.creatorDialog = false;
		},

		goForward() {
			this.offset = this.nextOffset;
			this.fetchTableData();
		},
		goBackward() {
			this.offset = Math.max(0, this.offset - this.rowNumbers);
			this.fetchTableData();
		},
		onRowNumberChange(rowCount) {
			this.rowNumbers = rowCount;
			this.fetchTableData();
		},

		getSearchParams() {
			let searchParam = "";
			if (this.selectedMonth) {
				searchParam += `&month=${this.selectedMonth}`;
			}
			if (this.selectedYear) {
				searchParam += `&year=${this.selectedYear}`;
			}
			if (this.searchForHandle) {
				const handleWithoutSymbol = this.searchForHandle.startsWith("@")
					? this.searchForHandle.substring(1)
					: this.searchForHandle;
				searchParam += `&userHandle=${handleWithoutSymbol}`;
			}
			if (this.bulkDownload) {
				searchParam += `&bulkDownload=${this.bulkDownload}`;
			}

			return searchParam;
		},

		async fetchTableData() {
			this.isGetInviteLoading = true;

			const headers = {
				"X-SHARECHAT-ACCESS-TOKEN": MOJ_TOOLS_ACCESS_TOKEN
			};

			const searchParam = this.getSearchParams();

			try {
				let endpoint = `${MOJ_TOOLS_BASE_URL}/livestream-tools-service/v1/public/agencies/${this.agencyId}/leaderboards?offset=${this.offset}&rowsPerPage=${this.rowNumbers}`;
				if (searchParam) endpoint += `${searchParam}`;
				const response = await ApiService.get(endpoint, headers);
				const { data, offset, totalRows } = response;
				if (this.bulkDownload) {
					this.bulkDownload = false;
					this.downloadReport(data);
				} else {
					this.allInvites = data;
					this.nextOffset = offset;
					this.totalEntries = totalRows;
				}
				this.isGetInviteLoading = false;
			} catch (e) {
				const errMsg =
					e.response.data.errMsg.message ||
					"Error occured while fetching invite list";
				this.$store.dispatch(SHOW_ALERT.dispatch, {
					text: errMsg
				});
				this.isGetInviteLoading = false;
			}
		},

		showAlert(message) {
			this.$store.dispatch(SHOW_ALERT.dispatch, {
				text: message
			});
		},

		downLoadHostPerformance() {
			this.bulkDownload = true;
			this.fetchTableData();
		},

		downloadReport(hostData) {
			const headers = Object.keys(this.overallCsvHeaders);
			const dataToDownload = getCsvRows(
				hostData,
				this.overallCsvHeaders,
				this.keysToRound
			);
			const date = new Date()
				.toISOString()
				.split("T")[0]
				.replace(/-/g, "");
			downloadArrayAsCsv(
				[[headers], ...dataToDownload],
				`Host Performance Report - ${this.selectedMonth} ${this.selectedYear} - ${date}`
			);
		},

		checkIfCurrentMonthAndYear() {
			const newDate = new Date();
			const currentYear = newDate.getFullYear();
			const currentMonth = newDate.getMonth();
			if (
				currentYear !== this.selectedYear ||
				MONTHS[currentMonth] !== this.selectedMonth
			) {
				this.headers[4].text = "Mints Earned";
			} else if (
				currentYear === this.selectedYear &&
				MONTHS[currentMonth] === this.selectedMonth
			) {
				this.headers[4].text = "Mints MTD";
			}
			if (!this.filterMonths.includes(this.selectedMonth)) {
				this.selectedMonth = this.filterMonths[
					this.filterMonths.length - 1
				];
			} else {
				this.fetchTableData();
			}
		}
	},
	watch: {
		selectedMonth() {
			this.checkIfCurrentMonthAndYear();
		},
		selectedYear() {
			this.checkIfCurrentMonthAndYear();
		}
	}
};
</script>

<style scoped>
.header {
	border-radius: 16px 16px 0 0;
	background-color: #edf0f7;
	color: #233b5d;
	font-weight: 500;
	font-size: 20px;
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.text-red {
	color: red;
}
.ml-2 {
	margin-left: 8px;
}
.filter-width {
	width: 200px;
}
.footer {
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
}

.footersm {
	flex-direction: column-reverse;
	align-items: flex-end;
}

.actions {
	display: flex;
	align-items: center;
}
.name-col {
	width: 200px;
	padding: 5px 0px 5px 0px;
}
.creator-name {
	margin-left: 10px;
	font-size: 15px;
	font-weight: 500;
}
.headerText {
	font-weight: 700;
	color: #000 !important;
	font-size: 14px !important;
}
.refreshText {
	font-weight: 700;
	font-size: 14px;
	margin-top: 20px;
	text-align: center;
}
</style>
